declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

const getViteEnv = (key: string) => {
  const viteEnv = import.meta.env as Record<string, string | undefined>;
  return (
    viteEnv[`VITE_${key}`] ??
    viteEnv[`NEXT_PUBLIC_${key}`] ??
    viteEnv[key]
  );
};

const isResolvedValue = (value?: string) =>
  Boolean(value?.trim()) && !value!.includes("${");

export const runtimeEnvCandidates = (key: string): string[] => {
  const candidates = [
    typeof window !== "undefined" ? window.__ENV__?.[key] : undefined,
    getViteEnv(key),
    typeof process !== "undefined" && process.env
      ? process.env[`NEXT_PUBLIC_${key}`]
      : undefined,
    typeof process !== "undefined" && process.env ? process.env[key] : undefined,
  ];

  return candidates
    .filter((value): value is string => isResolvedValue(value))
    .map((value) => value.trim());
};

/**
 * ランタイム環境変数読み出し。
 * 配信済み環境では window.__ENV__、ローカル開発では Vite の公開環境変数を利用する。
 */
export const runtimeEnv = (key: string, fallback?: string): string => {
  const value = runtimeEnvCandidates(key)[0];
  if (value) return value;
  return fallback ?? "";
};

export {};
